import utils from "../../../utils/utils.js";
export default {
    async fetchTagRules(context) {
        const response = await utils.utility.fetch(
            `api/Setting/GetTagRulesView`,
            "GET",
            null,
            null
          );
          context.commit("setTagRules", response.data);

    },
    async postTag(context, payload) {
        let postData = {
              Text: payload.tag,
              TagFlag: payload.flagType,
              ws: payload.workspaceId // workspace eklenmediği için yeni kayıt listeye yansımıyor olabilir
            };
        
            await utils.utility.fetch(
              `api/Setting/SimpleTagInsert`,
              "POST",
              null,
              postData
            );
            
            await context.dispatch("fetchTags");

    },
    async putTag(context, payload) {
        let postData = {

            Id:payload.id,
            Text: payload.tag,
            TagFlag: payload.flagType,
            ws: payload.workspaceId
          };
      
          await utils.utility.fetch(
            `api/Setting/SimpleTagUpdate`,
            "POST",
            null,
            postData
          );

          await context.dispatch("fetchTags");

    },
    async deleteTag(context, payload) {
    const postData = {
      Id: payload.id, // API bazı endpointlerde büyük I ile bekleyebilir
      id: payload.id, // geriye dönük
      ws: payload.workspaceId
    };
    await utils.utility.fetch(
      `api/Setting/SimpleTagDelete`,
      "POST",
      null,
      postData
    );
    await context.dispatch("fetchTags");
    },
    async postTagRule(context, payload) {
        let postData = {
            tagId: payload.tagId,
            ruleList: payload.ruleList
        };

        await utils.utility.fetch(
            `api/Setting/TagRuleInsert`,
            "POST",
            null,
            postData
        );

        await context.dispatch("fetchTagRules");
    },
    async deleteTagRule(context, payload) {
        let postData = {
          id:payload.id,
          ws: payload.workspaceId
        };
        await utils.utility.fetch(
          `api/Setting/TagRuleDelete`,
          "POST",
          null,
          postData
        );
  
        await context.dispatch("fetchTagRules");
    },

    async fetchTags(context) {
        const ws = context.rootGetters && context.rootGetters.workspaceId ? context.rootGetters.workspaceId : null;
        const url = ws ? `api/Setting/GetTagView?ws=${ws}` : "api/Setting/GetTagView";
        const response = await utils.utility.fetch(
            url,
            "GET",
            null,
            null
          );
          // DEBUG: fetch edilen ilk 5 kayıt ve id alanları
          // Debug loglar temizlendi
          context.commit("setTags", response.data);
    },
    async fetchWorkspaceTags(context) {
        const ws = context.rootGetters && context.rootGetters.workspaceId ? context.rootGetters.workspaceId : null;
        const url = ws ? `api/Setting/GetTagView?ws=${ws}` : "api/Setting/GetTagView";
        const response = await utils.utility.fetch(
            url,
            "GET",
            null,
            null
          );
          context.commit("setWorkspaceTags", response.data);
    }
}